/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Paste_CancelInputs */

const en_context_menu_paste_cancel = /** @type {(inputs: Context_Menu_Paste_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Original Timing`)
};

const fr_context_menu_paste_cancel = /** @type {(inputs: Context_Menu_Paste_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliser le timing d'origine`)
};

const de_context_menu_paste_cancel = /** @type {(inputs: Context_Menu_Paste_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originale Zündung verwenden`)
};

const it_context_menu_paste_cancel = /** @type {(inputs: Context_Menu_Paste_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa la temporizzazione originale`)
};

const ru_context_menu_paste_cancel = /** @type {(inputs: Context_Menu_Paste_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Использовать исходное время`)
};

const es_context_menu_paste_cancel = /** @type {(inputs: Context_Menu_Paste_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilice la sincronización original`)
};

const zh_cn2_context_menu_paste_cancel = /** @type {(inputs: Context_Menu_Paste_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用原时序`)
};

const ja_context_menu_paste_cancel = /** @type {(inputs: Context_Menu_Paste_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オリジナルのタイミングを使用する`)
};

const hi_context_menu_paste_cancel = /** @type {(inputs: Context_Menu_Paste_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल समय का उपयोग करें`)
};

const pt_pt2_context_menu_paste_cancel = /** @type {(inputs: Context_Menu_Paste_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a sincronização original`)
};

/**
* | output |
* | --- |
* | "Use Original Timing" |
*
* @param {Context_Menu_Paste_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_paste_cancel = /** @type {((inputs?: Context_Menu_Paste_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Paste_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_paste_cancel(inputs)
	if (locale === "de") return de_context_menu_paste_cancel(inputs)
	if (locale === "it") return it_context_menu_paste_cancel(inputs)
	if (locale === "ru") return ru_context_menu_paste_cancel(inputs)
	if (locale === "es") return es_context_menu_paste_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_paste_cancel(inputs)
	if (locale === "ja") return ja_context_menu_paste_cancel(inputs)
	if (locale === "hi") return hi_context_menu_paste_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_paste_cancel(inputs)
	return en_context_menu_paste_cancel(inputs)
});